/* unplugin-vue-components disabled */import { ElPagination as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/pagination/style/css';
import { ElTable as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/table/style/css';
import { ElTableColumn as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/table-column/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/input/style/css';
import _objectSpread from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  style: {
    "margin-top": "-20px",
    "margin-bottom": "10px"
  }
};
var _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_3 = {
  style: {
    "margin": "10px 0",
    "width": "95%"
  }
};
import { reactive, watchEffect } from "vue";
import { get_sample2 } from "@/api/apis";
export default {
  __name: 'sample',
  props: ['clientID'],
  emits: ['getSelectSample'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var currentRow = ref();
    var emit = __emit;
    var props = __props;
    var dataOwn = reactive({
      list: [] //
    });
    var search = reactive({
      key_word: "",
      //
      client_id: "",
      status: 5,
      type: 4
    });
    var fy = reactive({
      page: 1,
      limit: 10,
      total: 0
    });
    // 获取列表数据
    var getList = () => {
      var obj = {
        page: fy.page,
        limit: fy.limit
      };
      obj = _objectSpread(_objectSpread({}, obj), search);
      get_sample2(obj).then(res => {
        dataOwn.list = res.data.data || [];
        fy.total = res.data.total || 0;
      });
    };
    // getList();

    var handle_limit_change = () => {
      getList();
    };
    var handle_page_change = () => {
      getList();
    };
    watchEffect(() => {
      if (search.key_word) {
        fy.page = 1;
        getList();
      }
      if (props.clientID) {
        console.log("传过来的clientID->", props.clientID);
        search.client_id = props.clientID;
        fy.page = 1;
        getList();
      }
    });
    // 确定
    var handle_confirm = () => {
      // 向附件传递当前选中数据
      emit("getSelectSample", currentRow.value);
    };
    var handleCurrentChange = val => {
      currentRow.value = val;
    };
    return (_ctx, _cache) => {
      var _component_el_input = __unplugin_components_0;
      var _component_el_table_column = __unplugin_components_1;
      var _component_el_table = __unplugin_components_2;
      var _component_el_pagination = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
        style: {
          "width": "300px"
        },
        modelValue: search.key_word,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.key_word = $event),
        placeholder: "客户/销售员/单据编号/收货人"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_table, {
        style: {
          "width": "100%"
        },
        border: "",
        data: dataOwn.list,
        onCurrentChange: handleCurrentChange,
        "highlight-current-row": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "客户名称",
          prop: "client_name",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "单据编号",
          prop: "bills_code",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "申请人",
          prop: "apply_name",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "物料类型",
          prop: "supplies_type",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "销售员",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => {
            var _scope$row$sample_app;
            return [_createElementVNode("span", null, _toDisplayString((_scope$row$sample_app = scope.row.sample_apply_sale_user) === null || _scope$row$sample_app === void 0 ? void 0 : _scope$row$sample_app.name), 1)];
          }),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "收货人",
          property: ""
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.consignee_name), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "送样成本",
          prop: "cost"
        })]),
        _: 1
      }, 8, ["data"])]), _unref(currentRow) ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        onClick: handle_confirm,
        class: "iconfont icon-ziyuan165 blk_link",
        style: {
          "font-size": "30px",
          "display": "inline-block",
          "margin": "0 10px"
        }
      })) : _createCommentVNode("", true)]), _createVNode(_component_el_pagination, {
        "current-page": fy.page,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => fy.page = $event),
        style: {
          "margin-top": "10px"
        },
        small: "",
        background: "",
        layout: "prev, pager, next",
        "page-size": fy.limit,
        total: fy.total,
        onSizeChange: handle_limit_change,
        onCurrentChange: handle_page_change
      }, null, 8, ["current-page", "page-size", "total"])]);
    };
  }
};